import {
  createBrowserRouter,
  Outlet,
  useLoaderData,
  useLocation,
  useNavigate,
  useRouteError,
} from "react-router-dom";
import Login from "./pages/auth/Login";
import { Sidebar } from "./components/Sidebar";
import Header from "./components/Header";
import DashboardPage, { dashboardLoader } from "./pages/dashboard/DashboardPage";
import Api from "./api";
import { useContext, useEffect } from "react";
import {
  Backdrop,
  CircularProgress,
  Grid,
  Snackbar,
  Typography,
} from "@mui/material";
import UserContext, { UserProvider } from "./context/userContext";
import SiteDashboardPage, {
} from "./pages/site/dashboard/SiteDashboardPage";
import SiteLayout, { siteLoader } from "./pages/site/SiteLayout";
import SiteFirewallPage, {
} from "./pages/site/firewall/SiteFirewallPage";

import LocationWifi from "./pages/site/LocationWifi";
import LocationAlerts from "./pages/site/alerts/AlertsPage";
import LocationSettings from "./pages/site/settings/SiteSettingsPage";
import SwitchPage from "./pages/site/switch/SiteSwitchPage";
import OrderSitePage from "./pages/order_site/OrderSitePage";
import { Chart, registerables } from "chart.js";
import ErrorIcon from "@mui/icons-material/Error";
import SiteFilesPage from "./pages/site/files/SiteFilesPage";
import AdminPanelPage, { adminPanelLoader } from "./pages/admin_panel/AdminPanelPage";
Chart.register(...registerables);

function Layout() {
  const navigate = useNavigate();

  const {
    isLoading,
    setUserData,
    userData,
    snackbarText,
    setSnackbarText,
  } = useContext(UserContext);

  useEffect(() => {
    setTimeout(() => {
      setSnackbarText("");
    }, 2000);
  }, [setSnackbarText, snackbarText]);

  useEffect(() => {
    const getUser = async () => {
      try {
        const res = await Api.get("/auth");

        if(!res.use_twofactor){
          window.location.replace("/account/two_factor/setup/");
        }
        setUserData(res);
      } catch (e) {
        window.location.replace("/account/login/");
      }
    };
    if (userData == null) {
      getUser();
    }
  }, [navigate, setUserData, userData]);

  return (
    <>
      <Snackbar
        open={snackbarText !== ""}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        message={snackbarText}
      />
      <Backdrop
        sx={(theme) => ({ color: "#fff", zIndex: theme.zIndex.drawer + 1 })}
        open={isLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Header />
      <Outlet />
    </>
  );
}

function ErrorFallback(e: any) {
  const navigate = useNavigate();
  let error: any = useRouteError();

  useEffect(() => {
    if (error?.status === 403) {
      navigate("/login");
    }
  }, [error?.status, navigate]);

  return (
    <Grid
      container
      justifyContent="center"
      alignItems="center"
      sx={{ height: "90vh", textAlign: "center" }}
    >
      <Grid item>
        <ErrorIcon sx={{ fontSize: "4rem" }} />
        <Typography variant="h6">Something went wrong</Typography>
      </Grid>
    </Grid>
  );
}

export const router = createBrowserRouter([
  {
    element: <Login />,
    path: "login",
    errorElement: <ErrorFallback />,
  },
  {
    path: "admin_panel",
    element: <AdminPanelPage />,
    loader: adminPanelLoader,
    errorElement: <ErrorFallback />,
  },
  {
    element: <Layout />,
    path: "",
    children: [
      {
        path: "",
        element: <DashboardPage />,
        loader: dashboardLoader,
        errorElement: <ErrorFallback />,
      },
      {
        path: "sites/:id",
        element: <SiteLayout />,
        loader: siteLoader,
        errorElement: <ErrorFallback />,
        children: [
          {
            path: "dashboard",
            element: <SiteDashboardPage />,
          },
          {
            path: "firewalls",
            element: <SiteFirewallPage />,
          },
          {
            path: "switches",
            element: <SwitchPage />,
          },
          {
            path: "wifi",
            element: <LocationWifi />,
          },
          {
            path: "alerts",
            element: <LocationAlerts />,
          },
          {
            path: "files",
            element: <SiteFilesPage />,
          },
          {
            path: "settings",
            element: <LocationSettings />,
          },
        ],
      },
      {
        path: "new",
        element: <OrderSitePage />,
      },
    ],
  },

  {
    path: "/*",
    element: <>Page not found</>,
  },
]);
